import { render, staticRenderFns } from "./copyBomDetailHead.vue?vue&type=template&id=0a358e16&scoped=true&"
import script from "./copyBomDetailHead.vue?vue&type=script&lang=js&"
export * from "./copyBomDetailHead.vue?vue&type=script&lang=js&"
import style0 from "./copyBomDetailHead.vue?vue&type=style&index=0&id=0a358e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a358e16",
  null
  
)

export default component.exports